export const ROLES = ['admin', 'user'];
/** Minimum length of a password a user chooses (invite acceptance, password change). */
export const PASSWORD_MIN_LENGTH = 10;
/** Upper bound for any password the API accepts; keeps hashing cheap for absurd inputs. */
export const PASSWORD_MAX_LENGTH = 1024;
